import { createIntl, createIntlCache } from "@formatjs/intl";

const intl = createIntl(
  {
    locale: "zh-CN",
    messages: {},
  },
  createIntlCache()
);

/**金额格式化 */
export const priceFormat = (num, n = 2) => {
  return intl.formatNumber(num, {
    minimumFractionDigits: n,
  });
};

/**科学计数法 */
export const numberFormat = (value) => {
  return priceFormat(value, 0);
};
